import React from 'react';
import { FloorplanSettings } from '../../types';

interface FloorplanImageProps {
  floorplan: {
    url: string;
    width: number;
    height: number;
    settings?: FloorplanSettings;
  };
}

const FloorplanImage: React.FC<FloorplanImageProps> = ({ floorplan }) => {
  if (!floorplan?.url) {
    return null;
  }

  return (
    <img
      src={floorplan.url}
      alt="Floorplan"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        maxWidth: '100%',
        maxHeight: '100%',
        objectFit: 'contain',
        opacity: 0.8,
        zIndex: 1,
        pointerEvents: 'none'
      }}
    />
  );
};

export default FloorplanImage;